export default __webpack_public_path__ + "static/media/practice-test-5.296ea13b.csv";